import { getCoreDataSecurityApiRequestUsageSlice } from './get';

export const { requestGetCoreDataSecurityApiRequestUsage, resetGetCoreDataSecurityApiRequestUsage } =
    getCoreDataSecurityApiRequestUsageSlice.asyncActionCreators;
